module.exports = __webpack_public_path__ + "right-arrow.svg";